import Entity from '../entity'
export default class Campo extends Entity<number>{
    nombre: string;
    tipo: number;
    listSelectedRules: string;
}